var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top",attrs:{"id":"top"}},[_c('picture',[_c('source',{staticClass:"top-image",attrs:{"media":"(min-width: 980px)","srcset":_vm.pc}}),_c('img',{staticClass:"top-image",attrs:{"src":_vm.mobile,"alt":"top"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }